document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.header__inline-menu details').forEach(details => {
    const summary = details.querySelector('summary');
    if (!summary) return;

    // ✅ If this is the Products menu
    if (summary.id === 'HeaderMenu-products') {
      // Find the label (span or text)
      let labelNode = summary.querySelector('span');
      if (!labelNode) {
        labelNode = Array.from(summary.childNodes).find(
          node => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
        );
      }

      if (labelNode) {
        const text = (labelNode.textContent || '').trim();
        const link = document.createElement('a');
        link.textContent = text;
        link.href = 'https://kawaiharmony.com/collections/all'; // ✅ real backend link
        if (labelNode.nodeType === Node.ELEMENT_NODE && labelNode.className) {
          link.className = labelNode.className;
        }

        // Replace only the text/span with <a> (keep SVG caret)
        summary.replaceChild(link, labelNode);
      }
    }

    // 🟢 Open dropdown on hover
    details.addEventListener('mouseenter', () => details.setAttribute('open', ''));
    details.addEventListener('mouseleave', () => details.removeAttribute('open'));

    // 🟡 Prevent dropdown toggle on link click
    summary.addEventListener('click', (e) => {
      if (e.target.closest('a')) {
        e.stopPropagation(); // allow navigation
        return;
      }
      e.preventDefault(); // stop summary from toggling
    });
  });
});